import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, TextArea, Select } from '../../styled-components';
import localize from '../../util/localizeUtils';
import CharacterLimit from './CharacterLimit';
import ButtonWithIcon from './ButtonWithIcon';
import { ButtonContainer, Container } from './styled-components';

const PagesSelect = styled(Select)`
  height: 1.57rem;
  margin-right: 8px;
`;

const localstorage = window.localStorage;

class FacebookTabContent extends React.PureComponent {
  constructor(props) {
    super(props);
    const selectedPage = localstorage.getItem('fbTargetPage');
    this.state = {
      caption: '',
      postLength: 0,
      selectedPage
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.pages.length === 0 && nextProps.pages.length > 0 && !this.state.selectedPage) {
      this.setState({ selectedPage: nextProps.pages[0].id });
      localstorage.setItem('fbTargetPage', nextProps.pages[0].id);
    }
  }

  onChangeText = event => {
    const caption = event.target.value;
    this.setState({ caption, postLength: caption.length });
  };

  onPost = () => {
    this.props.onPost(this.state.caption, this.state.selectedPage);
  };

  updatePage = event => {
    this.setState({ selectedPage: event.target.value });
    localstorage.setItem('fbTargetPage', event.target.value);
  };

  renderLogIn() {
    const control = this.props.loggedInUser ? (
      <div>
        <span>{localize('loggedInFormat').replace('{user}', this.props.loggedInUser)}</span>
        <ButtonContainer paddingBottom="8px">
          <PagesSelect id="page-select" onChange={this.updatePage} value={this.state.selectedPage}>
            {this.props.pages
              ? this.props.pages.map(page => (
                <option key={page.id} value={page.id}>
                  {page.name}
                </option>
                ))
              : ''}
          </PagesSelect>
          <ButtonWithIcon
            style={{ marginRight: '8px' }}
            img="images/refresh.png"
            text={localize('changeUserButton')}
            onClick={this.props.onChangeUser}
          />
          <ButtonWithIcon img="images/facebook.png" text={localize('logOutButton')} onClick={this.props.onLogOut} />
        </ButtonContainer>
      </div>
    ) : (
      <ButtonWithIcon
        img="images/facebook.png"
        text={localize('publishLoginButton')}
        onClick={this.props.onLogIn}
      />
    );
    return <div style={{ paddingBottom: '8px' }}>{control}</div>;
  }

  render() {
    return (
      <Container>
        {this.renderLogIn()}
        <TextArea
          style={{ display: 'block ' }}
          height="100px"
          width="100%"
          onChange={this.onChangeText}
        />
        <ButtonContainer paddingTop="8px">
          <Button disabled={!this.props.loggedInUser || !this.state.caption} onClick={this.onPost}>
            {localize('postButton')}
          </Button>
        </ButtonContainer>
        <CharacterLimit visible={false} currentLength={this.state.postLength} max={63206} />
      </Container>
    );
  }
}

FacebookTabContent.defaultProps = {
  pages: []
};

FacebookTabContent.propTypes = {
  loggedInUser: PropTypes.string,
  onChangeUser: PropTypes.func.isRequired,
  onLogIn: PropTypes.func.isRequired,
  onLogOut: PropTypes.func.isRequired,
  onPost: PropTypes.func.isRequired,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  )
};

FacebookTabContent.defaultProps = {
  loggedInUser: ''
};

export default FacebookTabContent;



// WEBPACK FOOTER //
// ./app/components/PublishingDialog/FacebookTabContent.js